var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIconClear = function SvgFilterIconClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.125 9-1.7 1.7c-.353.353-.55.83-.55 1.327v2.44c0 .71-.401 1.359-1.037 1.676L8.125 17.5v-5.473c0-.498-.198-.974-.55-1.326L3.05 6.174A1.88 1.88 0 0 1 2.5 4.848v-.87c0-.45.32-.838.764-.913C5.454 2.693 7.704 2.5 10 2.5h2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 4,
    r: 2,
    fill: "#3AACC8"
  })));
};
export { SvgFilterIconClear as ReactComponent };
export default __webpack_public_path__ + "83e79732b9d7f1a0becbbb3798491fcb.svg";